import React from "react";
import classNames from "classnames";

import { task } from "@planzone/dto";
import {
  isToday,
  isWeekEnd,
  isHoliday,
  parseAsLocalDate,
} from "@pages/sharedTimeSheetUtils";
import { Record } from "./record";
import { ResourceTimeOverview } from "./resourceTimeOverview";
import { Props } from "./types";
import styles from "./styles.scss";

function RecordList(props: Props) {
  const { type } = props;

  return (
    <div
      className={classNames(styles.recordList, {
        [styles.resource]: type === "resource",
        [styles.list]: type === "project",
        [styles.list]: type === "list" || type === "project",
        [styles.task]: type === "task",
      })}
    >
      <div className={styles.dates}>
        {props.spentTimes
          .map(({ date, time, isAvailable }) => ({
            date: parseAsLocalDate(date),
            time,
            isAvailable,
          }))
          .map(({ date, time, isAvailable }) => {
            const record = props.records.find(
              (r) =>
                r.date === date.day &&
                r.month === date.month &&
                r.year === date.year,
            );
            const criteriaRecord = props.records.find((r) =>
              r.recordingDay?.startsWith(date.toISODate() ?? ""),
            );

            return (
              <div
                key={date.toISO() ?? ""}
                className={classNames(styles.record, {
                  [styles.resource]: type === "resource",
                  [styles.list]: type === "list" || type === "project",
                  [styles.today]: isToday(date),
                  [styles.weekEnd]: isWeekEnd(date),
                  [styles.unAvailable]: !isAvailable,
                })}
              >
                {type === "resource" ? (
                  <Record
                    record={record}
                    date={date}
                    type={type}
                    timeSpent={time}
                    timeSpentInWeek={props.spentTimeInWeek}
                    project={props.project}
                    resource={props.resource}
                    task={{ ...task, uuid: "" }}
                    isReloading={props.isReloading}
                  />
                ) : type === "list" || type === "project" ? (
                  <Record
                    record={record}
                    date={date}
                    timeSpent={time}
                    timeSpentInWeek={props.spentTimeInWeek}
                    type={type}
                    project={props.project}
                    resource={props.resource}
                    task={{ ...task, uuid: "" }}
                    isReloading={props.isReloading}
                  />
                ) : (
                  props.task && (
                    <Record
                      record={record}
                      date={date}
                      timeSpent={time}
                      timeSpentInWeek={props.spentTimeInWeek}
                      type={type}
                      project={props.project}
                      resource={props.resource}
                      task={props.task}
                      attributes={criteriaRecord?.attributes}
                      isReloading={props.isReloading}
                      timesheetDeadline={props.timesheetDeadline}
                    />
                  )
                )}
              </div>
            );
          })}
      </div>
      {props.areDetailsDisplayed && (
        <div className={styles.timeOverview}>
          <ResourceTimeOverview {...props} />
        </div>
      )}
    </div>
  );
}

export { RecordList };
